<template>
  <div id="home">
    <PluginHeader
      title="Translator"
      subtitle="Translate one dataset to another via sample points"
      icon="fas fa-sort-shapes-up"
    />
    <Alert />
    <Options />
    <TranslationMap />
    <Menu />
  </div><!-- /#home -->
</template>

<script>
import PluginHeader from '../_shared/PluginHeader.vue'
import Alert from './Alert'
import Options from './Options'
import TranslationMap from './TranslationMap'
import Menu from './Menu'
import translatorModule from './store/module.js'

export default {
  components: {
    PluginHeader,
    Alert,
    Options,
    TranslationMap,
    Menu
  },
  beforeCreate () {
    // Register the namespaced module fresh on entry so each visit
    // starts from clean state. Ported actions/mutations operate on
    // the scoped state, so registration is all the wiring needed.
    if (!this.$store.hasModule || !this.$store.hasModule('translator')) {
      this.$store.registerModule('translator', translatorModule)
    }
  },
  mounted () {
    // Wait for the DOM so TranslationMap's #translationMap container
    // exists before initTranslationMap constructs the mapbox map.
    this.$store.dispatch('translator/initPlugin')
  },
  beforeDestroy () {
    if (this.$store.hasModule && this.$store.hasModule('translator')) {
      this.$store.unregisterModule('translator')
    }
  }
}
</script>
